<template>
	<div class="modal-language-mobile" v-if="isOpen">
		<div class="mask" @click="closeModal"></div>
		<div class="modal">
			<div class="frame">
				<div class="icon-close" @click="closeModal">
					<span class="material-symbols-outlined" translate="no"> close </span>
				</div>
				<div class="modal-content">
					<div
						v-for="(lang, index) in languages"
						:key="index"
						class="language-switcher"
						:class="{ selected: lang.value === language }"
						@click="changeLanguage(lang.value)"
					>
						<div class="language-regions">
							<div class="flag-region">
								<img :src="lang.icon" :alt="`Flag ${lang.value}`" />
							</div>
							<p class="caption">{{ lang.text }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		isOpen: Boolean,
	},
	data() {
		return {
			entity: localStorage.getItem('userEntity'),
			language: this.$i18n.locale,
			languages: [
				{
					text: 'ENG',
					value: 'en',
					icon: '/assets/images/flags/gb.svg',
				},
				{
					text: '現代語',
					value: 'jp',
					icon: '/assets/images/flags/jp.svg',
				},
				{
					text: 'ESP',
					value: 'es',
					icon: '/assets/images/flags/es.svg',
				},
				{
					text: 'POR',
					value: 'pt',
					icon: '/assets/images/flags/pt.svg',
				},
				{
					text: 'عربي',
					value: 'ar',
					icon: '/assets/images/flags/ar.svg',
				},
				{
					text: '中国人',
					value: 'zh',
					icon: '/assets/images/flags/ch.svg',
				},
				{
					text: '한국인',
					value: 'ko',
					icon: '/assets/images/flags/kr.svg',
				},
				// {
				//   text: "ITA",
				//   value: "it",
				//   icon: "/assets/images/flags/it.svg",
				// },
				// {
				//   text: "POL",
				//   value: "pl",
				//   icon: "/assets/images/flags/pl.svg",
				// },
				// {
				//   text: "FRE",
				//   value: "fr",
				//   icon: "/assets/images/flags/fr.svg",
				// },
			],
		}
	},
	computed: {},
	watch: {
		language() {
			this.updatelanguage()
		},
	},
	mounted() {
		this.language = this.$i18n.locale
		this.languages = this.filterLanguages(this.entity)
	},
	methods: {
		filterLanguages(entity) {
			if (!entity) {
				return this.languages
			}
			switch (entity) {
				case 'LTD':
					return this.languages.filter((lang) =>
						['es', 'en'].includes(lang.value),
					)
				case 'LATAM':
					return this.languages.filter((lang) =>
						['en', 'es', 'pt'].includes(lang.value),
					)
				case 'JAPAN':
					return this.languages.filter((lang) =>
						['jp', 'es'].includes(lang.value),
					)
				case 'MENA':
					return this.languages.filter((lang) =>
						['ar', 'en'].includes(lang.value),
					)
				default:
					return this.allLanguages
			}
		},

		changeLanguage(value) {
			this.language = value
			this.$i18n.locale = value
			localStorage.setItem('language', value)

			const currentRoute = this.$router.currentRoute._value.fullPath
			const currentLocale = this.$router.currentRoute._value.params.locale
			const newPath = currentRoute.replace(`/${currentLocale}`, '')
			const newRoute = `/${this.language}${newPath}`

			window.location.href = newRoute

			this.$emit('language-changed', value)
			this.closeModal()
		},
		closeModal() {
			this.$emit('close')
		},
	},
}
</script>
